import dayjs from 'dayjs'

function getDays(date) {
  if (!date) return []
  const unit = 'day'
  const template = 'YYYY-MM-DD'
  // 时间戳
  const time = new Date(date).getTime()
  // 前一天
  const prev = dayjs(time).subtract(1, unit).format(template)
  // 当前
  const current = dayjs(time).format(template)
  // 后一天
  const next = dayjs(time).add(1, unit).format(template)
  // 天数集合
  return [prev, current, next]
}

export function createRange(d) {
  const days = getDays(d)
  return {
    disabledDate(t) {
      if (!d) return false
      const v = dayjs(t).format('YYYY-MM-DD')
      if (days.includes(v)) {
        return false
      }
      return true
    }
  }
}
